var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "swb-btn swb-btn-small mb10 fr",
        on: {
          click: function($event) {
            _vm.getXMsgList()
          }
        }
      },
      [_vm._v("刷新")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            ref: "multipleTable",
            staticStyle: { width: "100%" },
            attrs: { data: _vm.xMsgList, border: "", "tooltip-effect": "dark" }
          },
          [
            _c("el-table-column", {
              attrs: {
                align: "left",
                prop: "txt",
                label: "标题",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "left",
                label: "内容",
                "show-overflow-tooltip": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.data != null && rows.row.data.indexOf("{") >= 0
                        ? _c("span", [
                            _vm._v(_vm._s(JSON.decode(rows.row.data).message))
                          ])
                        : _c("span", [_vm._v(_vm._s(rows.row.data))])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "sendTime",
                width: "200",
                label: "发送时间",
                "show-overflow-tooltip": ""
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7377aa4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7377aa4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/msg/VoucherMsgList.vue
// module id = 1806
// module chunks = 1